/*
 * Interface strings for the "account" area. Keys are the Russian source strings exactly as they
 * appear in the components; a missing key falls back to Russian, so a partial dictionary is safe.
 * Russian itself is never listed here — it is the key.
 */
const account = {
  english: {
    "Скидка по подписке −{0}% выгоднее — применяется она": "Subscription discount −{0}% is better — that one applies",
    " · скидка {0}%": " · {0}% off",
    "Подписка «{0}»": "Subscription “{0}”",
    /* payment page: checkout details placeholder */
    'Оплата и обработка платежей': 'Payment and processing',
    'Платёжный провайдер': 'Payment provider',
    'Уточняется': 'To be confirmed',
    'Способы оплаты': 'Payment methods',
    'Валюта': 'Currency',
    'Доллар США (USD)': 'US dollar (USD)',
    'Зачисление звёзд': 'Stars credited',
    'Сразу после подтверждения платежа': 'Immediately after the payment is confirmed',
    'Возврат': 'Refunds',
    'Мы не храним данные банковских карт: при запуске оплаты они будут обрабатываться платёжным провайдером на его стороне.': 'We do not store card details: once payments go live they will be handled by the payment provider on their side.',
    '⭐ Получите 100 звёзд за регистрацию бесплатно!': '⭐ Get 100 free stars just for signing up!',
    /* general */
    'Загрузка…': 'Loading…',
    'Отмена': 'Cancel',
    'Отменить': 'Cancel',
    'Закрыть': 'Close',
    'На главную': 'Home',
    'Ошибка': 'Error',
    'Сохранение…': 'Saving…',
    'Отправка…': 'Sending…',
    'и': 'and',

    /* profile */
    'Мой аккаунт': 'My account',
    'Аккаунт': 'Account',
    'Пользователь': 'Username',
    'Дата регистрации': 'Member since',
    'Дата визита': 'First visit',
    'Выйти': 'Sign out',
    'Гость · войдите для полного доступа': 'Guest · sign in for full access',
    '⭐ Получите 100 звёзд за регистрацию и 100 звёзд за привязку Telegram аккаунта бесплатно!': '⭐ Get 100 free stars for signing up and 100 more for linking your Telegram account!',
    'Регистрация': 'Sign up',
    'Войти': 'Sign in',
    'Ошибка загрузки данных пользователя': 'Could not load your account',

    /* balance */
    'Баланс': 'Balance',
    'звёзд': 'stars',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Every message to a character costs at least 10 stars',
    'Пополнить счёт': 'Top up balance',

    /* email */
    'Email': 'Email',
    'Адрес': 'Address',
    'Статус': 'Status',
    '✅ Подтверждён': '✅ Confirmed',
    '⏳ Не подтверждён': '⏳ Not confirmed',
    '📬 Проверьте входящие и папку «Спам» — мы отправили письмо со ссылкой подтверждения. После подтверждения станет доступен сброс пароля по email.': '📬 Check your inbox and spam folder — we have sent you a confirmation link. Once confirmed, you can reset your password by email.',
    '📨 Отправить письмо повторно': '📨 Resend the email',
    '📨 Отправить повторно через {0} с': '📨 Resend in {0}s',
    '✏️ Изменить email': '✏️ Change email',
    'Укажите email для подтверждения аккаунта и восстановления пароля.': 'Add an email to confirm your account and recover your password.',
    'example@mail.ru': 'example@mail.com',
    'Текущий пароль для подтверждения': 'Current password to confirm',
    '💾 Сохранить email': '💾 Save email',
    '📨 Email сохранён. Письмо с подтверждением отправлено — проверьте почту.': '📨 Email saved. A confirmation message is on its way — check your inbox.',
    'Ошибка при сохранении email': 'Could not save your email',
    '📨 Письмо отправлено повторно — проверьте почту (и папку «Спам»).': '📨 Email sent again — check your inbox (and the spam folder).',
    'Ошибка при отправке письма': 'Could not send the email',

    /* password */
    'Пароль': 'Password',
    '✏️ Изменить пароль': '✏️ Change password',
    'Текущий пароль': 'Current password',
    'Новый пароль': 'New password',
    'Подтвердить новый пароль': 'Confirm new password',
    '💾 Сохранить пароль': '💾 Save password',
    'Новые пароли не совпадают': 'The new passwords do not match',
    'Пароль должен содержать минимум 6 символов': 'Password must be at least 6 characters',
    '✅ Пароль успешно изменён': '✅ Password changed',
    'Ошибка при изменении пароля': 'Could not change your password',

    /* telegram */
    'Код верификации': 'Verification code',
    'Скопируйте этот код и отправьте его в Telegram бот для подтверждения:': 'Copy this code and send it to the Telegram bot to confirm:',
    'Скопировано': 'Copied',
    'Копировать': 'Copy',
    'Скопируйте код выше': 'Copy the code above',
    'Откройте': 'Open',
    'Отправьте код в личном сообщении': 'Send the code in a private message',
    'Получите подтверждение и 100 звёзд!': 'Get your confirmation and 100 stars!',
    'Привязка…': 'Linking…',
    '🔗 Привязать Telegram': '🔗 Link Telegram',
    '⭐ Подтвердите подписку на Telegram и получите 100 звёзд!': '⭐ Confirm your Telegram subscription and get 100 stars!',
    '✅ Telegram привязан': '✅ Telegram linked',
    'Сбросить пароль: команда /change_password в боте': 'Reset your password: the /change_password command in the bot',
    'Отвязать': 'Unlink',
    'Привяжите аккаунт для восстановления пароля': 'Link your account to recover your password',
    '⚠️ Убедитесь, что у вашего Telegram аккаунта есть публичный username в настройках': '⚠️ Make sure your Telegram account has a public username in its settings',
    'Telegram аккаунт успешно привязан!': 'Telegram account linked!',
    'Ошибка привязки Telegram аккаунта': 'Could not link your Telegram account',
    'Вы уверены, что хотите отвязать Telegram аккаунт? Вы не сможете сбрасывать пароль через Telegram.': 'Unlink your Telegram account? You will no longer be able to reset your password through Telegram.',
    'Telegram аккаунт успешно отвязан!': 'Telegram account unlinked!',
    'Ошибка отвязки Telegram аккаунта': 'Could not unlink your Telegram account',

    /* my novels */
    'Мои новеллы': 'My novels',
    'У вас нет опубликованных новелл': 'You have no published novels',
    'Всего ходов: {0}': 'Total turns: {0}',
    'Нет данных': 'No data yet',
    'Месяц': 'Month',
    'Ходы': 'Turns',
    'Январь': 'January',
    'Февраль': 'February',
    'Март': 'March',
    'Апрель': 'April',
    'Май': 'May',
    'Июнь': 'June',
    'Июль': 'July',
    'Август': 'August',
    'Сентябрь': 'September',
    'Октябрь': 'October',
    'Ноябрь': 'November',
    'Декабрь': 'December',

    /* admin */
    'Администрирование': 'Administration',
    'Жалобы пользователей': 'User reports',
    'Скрыть форму': 'Hide form',
    'Опубликовать новость': 'Publish news',
    'Заголовок': 'Title',
    'Slug (латиницей, напр. konkurs-iyun)': 'Slug (Latin letters, e.g. contest-june)',
    'HTML-содержимое новости': 'News HTML content',
    'Публикация...': 'Publishing...',
    'Опубликовать': 'Publish',
    'Новость опубликована!': 'News post published!',

    /* auth modal */
    'Создать аккаунт': 'Create account',
    '⭐ Получите 100 звёзд за регистрацию + ещё 100 за привязку Telegram = 200 БЕСПЛАТНЫХ звёзд!': '⭐ 100 stars for signing up + 100 more for linking Telegram = 200 FREE stars!',
    'Зарегистрируйтесь, чтобы продолжить игру!': 'Sign up to keep playing!',
    'Имя пользователя': 'Username',
    'Подтвердить пароль': 'Confirm password',
    'Нажимая кнопку «Создать аккаунт», вы принимаете': 'By clicking “Create account” you accept our',
    'Пользовательское соглашение': 'Terms of Service',
    'Политику конфиденциальности': 'Privacy Policy',
    'Уже есть аккаунт? Войдите': 'Already have an account? Sign in',
    'Проверьте почту': 'Check your inbox',
    'Аккаунт создан! Мы отправили письмо со ссылкой для подтверждения email.': 'Account created! We have sent you a link to confirm your email.',
    'После подтверждения вы сможете войти в аккаунт.': 'Once confirmed, you can sign in to your account.',
    'Вход в аккаунт': 'Sign in',
    'Чтобы продолжить, войдите в аккаунт или зарегистрируйтесь': 'Sign in or create an account to continue',
    'Имя пользователя или email': 'Username or email',
    'Нужен аккаунт? Зарегистрируйтесь': 'Need an account? Sign up',
    'Забыли пароль?': 'Forgot your password?',
    'Восстановление пароля': 'Password recovery',
    'Введите ваше имя пользователя или email. Если аккаунт найден и email подтверждён — мы отправим ссылку для сброса пароля.': 'Enter your username or email. If the account exists and its email is confirmed, we will send a password reset link.',
    'Отправить письмо': 'Send email',
    'Вернуться ко входу': 'Back to sign in',
    'Письмо отправлено': 'Email sent',
    'Письмо со ссылкой для сброса пароля отправлено на ваш email.': 'We have sent a password reset link to your email.',
    'Ссылка действительна 1 час.': 'The link is valid for 1 hour.',
    'Пожалуйста, заполните все поля': 'Please fill in all the fields',
    'Пароли не совпадают': 'Passwords do not match',
    'Имя пользователя может содержать только английские буквы, цифры и нижнее подчёркивание': 'Usernames can only contain Latin letters, digits and underscores',
    'Введите корректный email': 'Enter a valid email address',
    'Аккаунт создан! Проверьте почту для подтверждения.': 'Account created! Check your inbox to confirm it.',
    'Вход выполнен успешно!': 'Signed in successfully!',
    'Ошибка регистрации': 'Registration failed',
    'Ошибка входа': 'Sign-in failed',
    'Введите имя пользователя или email': 'Enter your username or email',

    /* reset password page */
    'Пожалуйста, заполните оба поля.': 'Please fill in both fields.',
    'Пароли не совпадают.': 'Passwords do not match.',
    'Пароль должен содержать минимум 6 символов.': 'Password must be at least 6 characters.',
    'Не удалось сбросить пароль.': 'We could not reset your password.',
    'Пароль изменён!': 'Password changed!',
    'Теперь вы можете войти с новым паролем.': 'You can now sign in with your new password.',
    'Введите новый пароль для вашего аккаунта.': 'Choose a new password for your account.',
    'Ссылка недействительна. Запросите новую.': 'This link is not valid. Request a new one.',
    'Сохранить пароль': 'Save password',

    /* confirm email page */
    'Токен подтверждения отсутствует.': 'The confirmation token is missing.',
    'Email успешно подтверждён!': 'Your email has been confirmed!',
    'Аккаунт создан! Подтвердите email по ссылке из письма и получите {0} звёзд.': 'Account created! Confirm your email with the link we sent and get {0} stars.',
    '📧 Подтвердите email после регистрации и получите {0} бесплатных звёзд!': '📧 Confirm your email after signing up and get {0} free stars!',
    '📧 Новый игрок? Зарегистрируйтесь и подтвердите email — получите {0} звёзд бесплатно!': '📧 New here? Sign up and confirm your email to get {0} free stars!',
    'Вам начислено {0} звёзд за подтверждение email.': '{0} stars have been added to your balance for confirming your email.',
    'Не удалось подтвердить email.': 'We could not confirm your email.',
    'Ошибка соединения. Попробуйте позже.': 'Connection error. Please try again later.',
    'Подтверждаем ваш email…': 'Confirming your email…',
    'Email подтверждён!': 'Email confirmed!',
    'Перейти на главную': 'Go to home page',
  },

  german: {
    "Скидка по подписке −{0}% выгоднее — применяется она": "Abo-Rabatt −{0}% ist günstiger — er wird angewendet",
    " · скидка {0}%": " · {0}% Rabatt",
    "Подписка «{0}»": "Abo „{0}“",
    /* payment page: checkout details placeholder */
    'Оплата и обработка платежей': 'Zahlung und Abwicklung',
    'Платёжный провайдер': 'Zahlungsanbieter',
    'Уточняется': 'Wird noch festgelegt',
    'Способы оплаты': 'Zahlungsmethoden',
    'Валюта': 'Währung',
    'Доллар США (USD)': 'US-Dollar (USD)',
    'Зачисление звёзд': 'Gutschrift der Sterne',
    'Сразу после подтверждения платежа': 'Sofort nach Bestätigung der Zahlung',
    'Возврат': 'Rückerstattung',
    'Мы не храним данные банковских карт: при запуске оплаты они будут обрабатываться платёжным провайдером на его стороне.': 'Wir speichern keine Kartendaten: Sobald Zahlungen freigeschaltet sind, werden sie beim Zahlungsanbieter auf dessen Seite verarbeitet.',
    '⭐ Получите 100 звёзд за регистрацию бесплатно!': '⭐ Erhalte 100 kostenlose Sterne allein für die Registrierung!',
    /* general */
    'Загрузка…': 'Lädt…',
    'Отмена': 'Abbrechen',
    'Отменить': 'Abbrechen',
    'Закрыть': 'Schließen',
    'На главную': 'Zur Startseite',
    'Ошибка': 'Fehler',
    'Сохранение…': 'Wird gespeichert…',
    'Отправка…': 'Wird gesendet…',
    'и': 'und',

    /* profile */
    'Мой аккаунт': 'Mein Konto',
    'Аккаунт': 'Konto',
    'Пользователь': 'Benutzername',
    'Дата регистрации': 'Registriert seit',
    'Дата визита': 'Erster Besuch',
    'Выйти': 'Abmelden',
    'Гость · войдите для полного доступа': 'Gast · melde dich an für vollen Zugriff',
    '⭐ Получите 100 звёзд за регистрацию и 100 звёзд за привязку Telegram аккаунта бесплатно!': '⭐ Sichere dir 100 Sterne für die Registrierung und 100 weitere für die Verknüpfung deines Telegram-Kontos — gratis!',
    'Регистрация': 'Registrieren',
    'Войти': 'Anmelden',
    'Ошибка загрузки данных пользователя': 'Dein Konto konnte nicht geladen werden',

    /* balance */
    'Баланс': 'Guthaben',
    'звёзд': 'Sterne',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Jede Nachricht an eine Figur kostet mindestens 10 Sterne',
    'Пополнить счёт': 'Guthaben aufladen',

    /* email */
    'Email': 'E-Mail',
    'Адрес': 'Adresse',
    'Статус': 'Status',
    '✅ Подтверждён': '✅ Bestätigt',
    '⏳ Не подтверждён': '⏳ Nicht bestätigt',
    '📬 Проверьте входящие и папку «Спам» — мы отправили письмо со ссылкой подтверждения. После подтверждения станет доступен сброс пароля по email.': '📬 Schau in deinen Posteingang und den Spam-Ordner — wir haben dir einen Bestätigungslink geschickt. Nach der Bestätigung kannst du dein Passwort per E-Mail zurücksetzen.',
    '📨 Отправить письмо повторно': '📨 E-Mail erneut senden',
    '📨 Отправить повторно через {0} с': '📨 Erneut senden in {0} s',
    '✏️ Изменить email': '✏️ E-Mail ändern',
    'Укажите email для подтверждения аккаунта и восстановления пароля.': 'Hinterlege eine E-Mail-Adresse, um dein Konto zu bestätigen und dein Passwort wiederherstellen zu können.',
    'example@mail.ru': 'beispiel@mail.com',
    'Текущий пароль для подтверждения': 'Aktuelles Passwort zur Bestätigung',
    '💾 Сохранить email': '💾 E-Mail speichern',
    '📨 Email сохранён. Письмо с подтверждением отправлено — проверьте почту.': '📨 E-Mail gespeichert. Die Bestätigungsmail ist unterwegs — schau in dein Postfach.',
    'Ошибка при сохранении email': 'Deine E-Mail konnte nicht gespeichert werden',
    '📨 Письмо отправлено повторно — проверьте почту (и папку «Спам»).': '📨 E-Mail erneut gesendet — schau in dein Postfach (und den Spam-Ordner).',
    'Ошибка при отправке письма': 'Die E-Mail konnte nicht gesendet werden',

    /* password */
    'Пароль': 'Passwort',
    '✏️ Изменить пароль': '✏️ Passwort ändern',
    'Текущий пароль': 'Aktuelles Passwort',
    'Новый пароль': 'Neues Passwort',
    'Подтвердить новый пароль': 'Neues Passwort bestätigen',
    '💾 Сохранить пароль': '💾 Passwort speichern',
    'Новые пароли не совпадают': 'Die neuen Passwörter stimmen nicht überein',
    'Пароль должен содержать минимум 6 символов': 'Das Passwort muss mindestens 6 Zeichen lang sein',
    '✅ Пароль успешно изменён': '✅ Passwort geändert',
    'Ошибка при изменении пароля': 'Dein Passwort konnte nicht geändert werden',

    /* telegram */
    'Код верификации': 'Bestätigungscode',
    'Скопируйте этот код и отправьте его в Telegram бот для подтверждения:': 'Kopiere diesen Code und sende ihn zur Bestätigung an den Telegram-Bot:',
    'Скопировано': 'Kopiert',
    'Копировать': 'Kopieren',
    'Скопируйте код выше': 'Kopiere den Code oben',
    'Откройте': 'Öffne',
    'Отправьте код в личном сообщении': 'Sende den Code als private Nachricht',
    'Получите подтверждение и 100 звёзд!': 'Erhalte deine Bestätigung und 100 Sterne!',
    'Привязка…': 'Wird verknüpft…',
    '🔗 Привязать Telegram': '🔗 Telegram verknüpfen',
    '⭐ Подтвердите подписку на Telegram и получите 100 звёзд!': '⭐ Bestätige dein Telegram-Abo und erhalte 100 Sterne!',
    '✅ Telegram привязан': '✅ Telegram verknüpft',
    'Сбросить пароль: команда /change_password в боте': 'Passwort zurücksetzen: Befehl /change_password im Bot',
    'Отвязать': 'Trennen',
    'Привяжите аккаунт для восстановления пароля': 'Verknüpfe dein Konto, um dein Passwort wiederherstellen zu können',
    '⚠️ Убедитесь, что у вашего Telegram аккаунта есть публичный username в настройках': '⚠️ Stelle sicher, dass dein Telegram-Konto in den Einstellungen einen öffentlichen Benutzernamen hat',
    'Telegram аккаунт успешно привязан!': 'Telegram-Konto verknüpft!',
    'Ошибка привязки Telegram аккаунта': 'Dein Telegram-Konto konnte nicht verknüpft werden',
    'Вы уверены, что хотите отвязать Telegram аккаунт? Вы не сможете сбрасывать пароль через Telegram.': 'Telegram-Konto wirklich trennen? Du kannst dein Passwort dann nicht mehr über Telegram zurücksetzen.',
    'Telegram аккаунт успешно отвязан!': 'Telegram-Konto getrennt!',
    'Ошибка отвязки Telegram аккаунта': 'Dein Telegram-Konto konnte nicht getrennt werden',

    /* my novels */
    'Мои новеллы': 'Meine Novels',
    'У вас нет опубликованных новелл': 'Du hast noch keine veröffentlichten Novels',
    'Всего ходов: {0}': 'Züge insgesamt: {0}',
    'Нет данных': 'Keine Daten',
    'Месяц': 'Monat',
    'Ходы': 'Züge',
    'Январь': 'Januar',
    'Февраль': 'Februar',
    'Март': 'März',
    'Апрель': 'April',
    'Май': 'Mai',
    'Июнь': 'Juni',
    'Июль': 'Juli',
    'Август': 'August',
    'Сентябрь': 'September',
    'Октябрь': 'Oktober',
    'Ноябрь': 'November',
    'Декабрь': 'Dezember',

    /* admin */
    'Администрирование': 'Administration',
    'Жалобы пользователей': 'Nutzermeldungen',
    'Скрыть форму': 'Formular ausblenden',
    'Опубликовать новость': 'News veröffentlichen',
    'Заголовок': 'Titel',
    'Slug (латиницей, напр. konkurs-iyun)': 'Slug (lateinische Buchstaben, z. B. contest-june)',
    'HTML-содержимое новости': 'HTML-Inhalt der News',
    'Публикация...': 'Wird veröffentlicht...',
    'Опубликовать': 'Veröffentlichen',
    'Новость опубликована!': 'News veröffentlicht!',

    /* auth modal */
    'Создать аккаунт': 'Konto erstellen',
    '⭐ Получите 100 звёзд за регистрацию + ещё 100 за привязку Telegram = 200 БЕСПЛАТНЫХ звёзд!': '⭐ 100 Sterne für die Registrierung + 100 für Telegram = 200 GRATIS-Sterne!',
    'Зарегистрируйтесь, чтобы продолжить игру!': 'Registriere dich, um weiterzuspielen!',
    'Имя пользователя': 'Benutzername',
    'Подтвердить пароль': 'Passwort bestätigen',
    'Нажимая кнопку «Создать аккаунт», вы принимаете': 'Mit Klick auf „Konto erstellen“ akzeptierst du unsere',
    'Пользовательское соглашение': 'Nutzungsbedingungen',
    'Политику конфиденциальности': 'Datenschutzerklärung',
    'Уже есть аккаунт? Войдите': 'Schon ein Konto? Melde dich an',
    'Проверьте почту': 'Schau in dein Postfach',
    'Аккаунт создан! Мы отправили письмо со ссылкой для подтверждения email.': 'Konto erstellt! Wir haben dir einen Link zur Bestätigung deiner E-Mail geschickt.',
    'После подтверждения вы сможете войти в аккаунт.': 'Nach der Bestätigung kannst du dich anmelden.',
    'Вход в аккаунт': 'Anmelden',
    'Чтобы продолжить, войдите в аккаунт или зарегистрируйтесь': 'Melde dich an oder registriere dich, um weiterzumachen',
    'Имя пользователя или email': 'Benutzername oder E-Mail',
    'Нужен аккаунт? Зарегистрируйтесь': 'Noch kein Konto? Registriere dich',
    'Забыли пароль?': 'Passwort vergessen?',
    'Восстановление пароля': 'Passwort wiederherstellen',
    'Введите ваше имя пользователя или email. Если аккаунт найден и email подтверждён — мы отправим ссылку для сброса пароля.': 'Gib deinen Benutzernamen oder deine E-Mail ein. Wenn das Konto existiert und die E-Mail bestätigt ist, senden wir dir einen Link zum Zurücksetzen des Passworts.',
    'Отправить письмо': 'E-Mail senden',
    'Вернуться ко входу': 'Zurück zur Anmeldung',
    'Письмо отправлено': 'E-Mail gesendet',
    'Письмо со ссылкой для сброса пароля отправлено на ваш email.': 'Wir haben dir einen Link zum Zurücksetzen des Passworts geschickt.',
    'Ссылка действительна 1 час.': 'Der Link ist 1 Stunde gültig.',
    'Пожалуйста, заполните все поля': 'Bitte fülle alle Felder aus',
    'Пароли не совпадают': 'Die Passwörter stimmen nicht überein',
    'Имя пользователя может содержать только английские буквы, цифры и нижнее подчёркивание': 'Der Benutzername darf nur lateinische Buchstaben, Ziffern und Unterstriche enthalten',
    'Введите корректный email': 'Gib eine gültige E-Mail-Adresse ein',
    'Аккаунт создан! Проверьте почту для подтверждения.': 'Konto erstellt! Schau zur Bestätigung in dein Postfach.',
    'Вход выполнен успешно!': 'Erfolgreich angemeldet!',
    'Ошибка регистрации': 'Registrierung fehlgeschlagen',
    'Ошибка входа': 'Anmeldung fehlgeschlagen',
    'Введите имя пользователя или email': 'Gib deinen Benutzernamen oder deine E-Mail ein',

    /* reset password page */
    'Пожалуйста, заполните оба поля.': 'Bitte fülle beide Felder aus.',
    'Пароли не совпадают.': 'Die Passwörter stimmen nicht überein.',
    'Пароль должен содержать минимум 6 символов.': 'Das Passwort muss mindestens 6 Zeichen lang sein.',
    'Не удалось сбросить пароль.': 'Das Passwort konnte nicht zurückgesetzt werden.',
    'Пароль изменён!': 'Passwort geändert!',
    'Теперь вы можете войти с новым паролем.': 'Du kannst dich jetzt mit deinem neuen Passwort anmelden.',
    'Введите новый пароль для вашего аккаунта.': 'Wähle ein neues Passwort für dein Konto.',
    'Ссылка недействительна. Запросите новую.': 'Dieser Link ist ungültig. Fordere einen neuen an.',
    'Сохранить пароль': 'Passwort speichern',

    /* confirm email page */
    'Токен подтверждения отсутствует.': 'Der Bestätigungstoken fehlt.',
    'Email успешно подтверждён!': 'Deine E-Mail wurde bestätigt!',
    'Аккаунт создан! Подтвердите email по ссылке из письма и получите {0} звёзд.': 'Konto erstellt! Bestätige deine E-Mail über den Link in unserer Nachricht und erhalte {0} Sterne.',
    '📧 Подтвердите email после регистрации и получите {0} бесплатных звёзд!': '📧 Bestätige nach der Registrierung deine E-Mail und erhalte {0} Gratis-Sterne!',
    '📧 Новый игрок? Зарегистрируйтесь и подтвердите email — получите {0} звёзд бесплатно!': '📧 Neu hier? Registriere dich und bestätige deine E-Mail — {0} Sterne gratis!',
    'Вам начислено {0} звёзд за подтверждение email.': 'Dir wurden {0} Sterne für die Bestätigung deiner E-Mail gutgeschrieben.',
    'Не удалось подтвердить email.': 'Deine E-Mail konnte nicht bestätigt werden.',
    'Ошибка соединения. Попробуйте позже.': 'Verbindungsfehler. Bitte versuche es später erneut.',
    'Подтверждаем ваш email…': 'Deine E-Mail wird bestätigt…',
    'Email подтверждён!': 'E-Mail bestätigt!',
    'Перейти на главную': 'Zur Startseite',
  },

  french: {
    "Скидка по подписке −{0}% выгоднее — применяется она": "La remise abonnement −{0}% est meilleure — c’est elle qui s’applique",
    " · скидка {0}%": " · {0}% de remise",
    "Подписка «{0}»": "Abonnement « {0} »",
    /* payment page: checkout details placeholder */
    'Оплата и обработка платежей': 'Paiement et traitement',
    'Платёжный провайдер': 'Prestataire de paiement',
    'Уточняется': 'À confirmer',
    'Способы оплаты': 'Moyens de paiement',
    'Валюта': 'Devise',
    'Доллар США (USD)': 'Dollar américain (USD)',
    'Зачисление звёзд': 'Créditement des Étoiles',
    'Сразу после подтверждения платежа': 'Immédiatement après confirmation du paiement',
    'Возврат': 'Remboursement',
    'Мы не храним данные банковских карт: при запуске оплаты они будут обрабатываться платёжным провайдером на его стороне.': "Nous ne conservons pas les données bancaires : dès l'ouverture des paiements, elles seront traitées par le prestataire de paiement, de son côté.",
    '⭐ Получите 100 звёзд за регистрацию бесплатно!': '⭐ Reçois 100 étoiles gratuites rien qu\'en t\'inscrivant !',
    /* general */
    'Загрузка…': 'Chargement…',
    'Отмена': 'Annuler',
    'Отменить': 'Annuler',
    'Закрыть': 'Fermer',
    'На главную': "Accueil",
    'Ошибка': 'Erreur',
    'Сохранение…': 'Enregistrement…',
    'Отправка…': 'Envoi…',
    'и': 'et',

    /* profile */
    'Мой аккаунт': 'Mon compte',
    'Аккаунт': 'Compte',
    'Пользователь': "Nom d'utilisateur",
    'Дата регистрации': "Inscrit depuis le",
    'Дата визита': 'Première visite',
    'Выйти': 'Se déconnecter',
    'Гость · войдите для полного доступа': 'Invité · connectez-vous pour un accès complet',
    '⭐ Получите 100 звёзд за регистрацию и 100 звёзд за привязку Telegram аккаунта бесплатно!': '⭐ Recevez 100 étoiles pour votre inscription et 100 de plus en liant votre compte Telegram, gratuitement !',
    'Регистрация': "S'inscrire",
    'Войти': 'Se connecter',
    'Ошибка загрузки данных пользователя': 'Impossible de charger votre compte',

    /* balance */
    'Баланс': 'Solde',
    'звёзд': 'étoiles',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Chaque message envoyé à un personnage coûte au moins 10 étoiles',
    'Пополнить счёт': 'Recharger le solde',

    /* email */
    'Email': 'E-mail',
    'Адрес': 'Adresse',
    'Статус': 'Statut',
    '✅ Подтверждён': '✅ Confirmé',
    '⏳ Не подтверждён': '⏳ Non confirmé',
    '📬 Проверьте входящие и папку «Спам» — мы отправили письмо со ссылкой подтверждения. После подтверждения станет доступен сброс пароля по email.': '📬 Vérifiez votre boîte de réception et vos spams — nous vous avons envoyé un lien de confirmation. Une fois confirmé, vous pourrez réinitialiser votre mot de passe par e-mail.',
    '📨 Отправить письмо повторно': "📨 Renvoyer l'e-mail",
    '📨 Отправить повторно через {0} с': '📨 Renvoyer dans {0} s',
    '✏️ Изменить email': "✏️ Modifier l'e-mail",
    'Укажите email для подтверждения аккаунта и восстановления пароля.': 'Indiquez une adresse e-mail pour confirmer votre compte et récupérer votre mot de passe.',
    'example@mail.ru': 'exemple@mail.com',
    'Текущий пароль для подтверждения': 'Mot de passe actuel pour confirmer',
    '💾 Сохранить email': "💾 Enregistrer l'e-mail",
    '📨 Email сохранён. Письмо с подтверждением отправлено — проверьте почту.': '📨 E-mail enregistré. Le message de confirmation est en route — consultez votre boîte de réception.',
    'Ошибка при сохранении email': "Impossible d'enregistrer votre e-mail",
    '📨 Письмо отправлено повторно — проверьте почту (и папку «Спам»).': '📨 E-mail renvoyé — consultez votre boîte de réception (et vos spams).',
    'Ошибка при отправке письма': "Impossible d'envoyer l'e-mail",

    /* password */
    'Пароль': 'Mot de passe',
    '✏️ Изменить пароль': '✏️ Changer de mot de passe',
    'Текущий пароль': 'Mot de passe actuel',
    'Новый пароль': 'Nouveau mot de passe',
    'Подтвердить новый пароль': 'Confirmer le nouveau mot de passe',
    '💾 Сохранить пароль': '💾 Enregistrer le mot de passe',
    'Новые пароли не совпадают': 'Les nouveaux mots de passe ne correspondent pas',
    'Пароль должен содержать минимум 6 символов': 'Le mot de passe doit contenir au moins 6 caractères',
    '✅ Пароль успешно изменён': '✅ Mot de passe modifié',
    'Ошибка при изменении пароля': 'Impossible de modifier votre mot de passe',

    /* telegram */
    'Код верификации': 'Code de vérification',
    'Скопируйте этот код и отправьте его в Telegram бот для подтверждения:': 'Copiez ce code et envoyez-le au bot Telegram pour confirmer :',
    'Скопировано': 'Copié',
    'Копировать': 'Copier',
    'Скопируйте код выше': 'Copiez le code ci-dessus',
    'Откройте': 'Ouvrez',
    'Отправьте код в личном сообщении': 'Envoyez le code en message privé',
    'Получите подтверждение и 100 звёзд!': 'Recevez votre confirmation et 100 étoiles !',
    'Привязка…': 'Liaison…',
    '🔗 Привязать Telegram': '🔗 Lier Telegram',
    '⭐ Подтвердите подписку на Telegram и получите 100 звёзд!': '⭐ Confirmez votre abonnement Telegram et recevez 100 étoiles !',
    '✅ Telegram привязан': '✅ Telegram lié',
    'Сбросить пароль: команда /change_password в боте': 'Réinitialiser le mot de passe : commande /change_password dans le bot',
    'Отвязать': 'Dissocier',
    'Привяжите аккаунт для восстановления пароля': 'Liez votre compte pour pouvoir récupérer votre mot de passe',
    '⚠️ Убедитесь, что у вашего Telegram аккаунта есть публичный username в настройках': "⚠️ Assurez-vous que votre compte Telegram possède un nom d'utilisateur public dans ses paramètres",
    'Telegram аккаунт успешно привязан!': 'Compte Telegram lié !',
    'Ошибка привязки Telegram аккаунта': 'Impossible de lier votre compte Telegram',
    'Вы уверены, что хотите отвязать Telegram аккаунт? Вы не сможете сбрасывать пароль через Telegram.': 'Voulez-vous vraiment dissocier votre compte Telegram ? Vous ne pourrez plus réinitialiser votre mot de passe via Telegram.',
    'Telegram аккаунт успешно отвязан!': 'Compte Telegram dissocié !',
    'Ошибка отвязки Telegram аккаунта': 'Impossible de dissocier votre compte Telegram',

    /* my novels */
    'Мои новеллы': 'Mes romans',
    'У вас нет опубликованных новелл': "Vous n'avez aucun roman publié",
    'Всего ходов: {0}': 'Total des tours : {0}',
    'Нет данных': 'Aucune donnée',
    'Месяц': 'Mois',
    'Ходы': 'Tours',
    'Январь': 'Janvier',
    'Февраль': 'Février',
    'Март': 'Mars',
    'Апрель': 'Avril',
    'Май': 'Mai',
    'Июнь': 'Juin',
    'Июль': 'Juillet',
    'Август': 'Août',
    'Сентябрь': 'Septembre',
    'Октябрь': 'Octobre',
    'Ноябрь': 'Novembre',
    'Декабрь': 'Décembre',

    /* admin */
    'Администрирование': 'Administration',
    'Жалобы пользователей': 'Signalements des utilisateurs',
    'Скрыть форму': 'Masquer le formulaire',
    'Опубликовать новость': 'Publier une actualité',
    'Заголовок': 'Titre',
    'Slug (латиницей, напр. konkurs-iyun)': 'Slug (lettres latines, ex. contest-june)',
    'HTML-содержимое новости': "Contenu HTML de l'actualité",
    'Публикация...': 'Publication...',
    'Опубликовать': 'Publier',
    'Новость опубликована!': 'Actualité publiée !',

    /* auth modal */
    'Создать аккаунт': 'Créer un compte',
    '⭐ Получите 100 звёзд за регистрацию + ещё 100 за привязку Telegram = 200 БЕСПЛАТНЫХ звёзд!': "⭐ 100 étoiles à l'inscription + 100 pour Telegram = 200 étoiles GRATUITES !",
    'Зарегистрируйтесь, чтобы продолжить игру!': 'Inscrivez-vous pour continuer à jouer !',
    'Имя пользователя': "Nom d'utilisateur",
    'Подтвердить пароль': 'Confirmer le mot de passe',
    'Нажимая кнопку «Создать аккаунт», вы принимаете': 'En cliquant sur « Créer un compte », vous acceptez nos',
    'Пользовательское соглашение': "Conditions d'utilisation",
    'Политику конфиденциальности': 'Politique de confidentialité',
    'Уже есть аккаунт? Войдите': 'Vous avez déjà un compte ? Connectez-vous',
    'Проверьте почту': 'Consultez votre boîte mail',
    'Аккаунт создан! Мы отправили письмо со ссылкой для подтверждения email.': 'Compte créé ! Nous vous avons envoyé un lien pour confirmer votre e-mail.',
    'После подтверждения вы сможете войти в аккаунт.': 'Une fois confirmé, vous pourrez vous connecter.',
    'Вход в аккаунт': 'Connexion',
    'Чтобы продолжить, войдите в аккаунт или зарегистрируйтесь': 'Connectez-vous ou créez un compte pour continuer',
    'Имя пользователя или email': "Nom d'utilisateur ou e-mail",
    'Нужен аккаунт? Зарегистрируйтесь': 'Pas encore de compte ? Inscrivez-vous',
    'Забыли пароль?': 'Mot de passe oublié ?',
    'Восстановление пароля': 'Récupération du mot de passe',
    'Введите ваше имя пользователя или email. Если аккаунт найден и email подтверждён — мы отправим ссылку для сброса пароля.': "Saisissez votre nom d'utilisateur ou votre e-mail. Si le compte existe et que son e-mail est confirmé, nous enverrons un lien de réinitialisation.",
    'Отправить письмо': "Envoyer l'e-mail",
    'Вернуться ко входу': 'Retour à la connexion',
    'Письмо отправлено': 'E-mail envoyé',
    'Письмо со ссылкой для сброса пароля отправлено на ваш email.': 'Nous avons envoyé un lien de réinitialisation à votre adresse e-mail.',
    'Ссылка действительна 1 час.': 'Le lien est valable 1 heure.',
    'Пожалуйста, заполните все поля': 'Veuillez remplir tous les champs',
    'Пароли не совпадают': 'Les mots de passe ne correspondent pas',
    'Имя пользователя может содержать только английские буквы, цифры и нижнее подчёркивание': "Le nom d'utilisateur ne peut contenir que des lettres latines, des chiffres et des tirets bas",
    'Введите корректный email': 'Saisissez une adresse e-mail valide',
    'Аккаунт создан! Проверьте почту для подтверждения.': 'Compte créé ! Consultez votre boîte mail pour le confirmer.',
    'Вход выполнен успешно!': 'Connexion réussie !',
    'Ошибка регистрации': "Échec de l'inscription",
    'Ошибка входа': 'Échec de la connexion',
    'Введите имя пользователя или email': "Saisissez votre nom d'utilisateur ou votre e-mail",

    /* reset password page */
    'Пожалуйста, заполните оба поля.': 'Veuillez remplir les deux champs.',
    'Пароли не совпадают.': 'Les mots de passe ne correspondent pas.',
    'Пароль должен содержать минимум 6 символов.': 'Le mot de passe doit contenir au moins 6 caractères.',
    'Не удалось сбросить пароль.': "Impossible de réinitialiser le mot de passe.",
    'Пароль изменён!': 'Mot de passe modifié !',
    'Теперь вы можете войти с новым паролем.': 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
    'Введите новый пароль для вашего аккаунта.': 'Choisissez un nouveau mot de passe pour votre compte.',
    'Ссылка недействительна. Запросите новую.': 'Ce lien est invalide. Demandez-en un nouveau.',
    'Сохранить пароль': 'Enregistrer le mot de passe',

    /* confirm email page */
    'Токен подтверждения отсутствует.': 'Le jeton de confirmation est manquant.',
    'Email успешно подтверждён!': 'Votre e-mail a bien été confirmé !',
    'Аккаунт создан! Подтвердите email по ссылке из письма и получите {0} звёзд.': 'Compte créé ! Confirmez votre e-mail grâce au lien reçu et gagnez {0} étoiles.',
    '📧 Подтвердите email после регистрации и получите {0} бесплатных звёзд!': '📧 Confirmez votre e-mail après votre inscription et recevez {0} étoiles gratuites !',
    '📧 Новый игрок? Зарегистрируйтесь и подтвердите email — получите {0} звёзд бесплатно!': '📧 Nouveau ici ? Inscrivez-vous et confirmez votre e-mail — {0} étoiles offertes !',
    'Вам начислено {0} звёзд за подтверждение email.': '{0} étoiles ont été ajoutées à votre solde pour la confirmation de votre e-mail.',
    'Не удалось подтвердить email.': "Impossible de confirmer votre e-mail.",
    'Ошибка соединения. Попробуйте позже.': 'Erreur de connexion. Réessayez plus tard.',
    'Подтверждаем ваш email…': 'Confirmation de votre e-mail…',
    'Email подтверждён!': 'E-mail confirmé !',
    'Перейти на главную': "Aller à l'accueil",
  },

  spanish: {
    "Скидка по подписке −{0}% выгоднее — применяется она": "El descuento de suscripción −{0}% es mejor: se aplica ese",
    " · скидка {0}%": " · {0}% de descuento",
    "Подписка «{0}»": "Suscripción «{0}»",
    /* payment page: checkout details placeholder */
    'Оплата и обработка платежей': 'Pago y procesamiento',
    'Платёжный провайдер': 'Proveedor de pago',
    'Уточняется': 'Por confirmar',
    'Способы оплаты': 'Métodos de pago',
    'Валюта': 'Moneda',
    'Доллар США (USD)': 'Dólar estadounidense (USD)',
    'Зачисление звёзд': 'Abono de Estrellas',
    'Сразу после подтверждения платежа': 'Inmediatamente tras confirmarse el pago',
    'Возврат': 'Reembolsos',
    'Мы не храним данные банковских карт: при запуске оплаты они будут обрабатываться платёжным провайдером на его стороне.': 'No almacenamos datos de tarjetas: cuando se habiliten los pagos, los tratará el proveedor de pago en su propio sistema.',
    '⭐ Получите 100 звёзд за регистрацию бесплатно!': '⭐ ¡Consigue 100 estrellas gratis solo por registrarte!',
    /* general */
    'Загрузка…': 'Cargando…',
    'Отмена': 'Cancelar',
    'Отменить': 'Cancelar',
    'Закрыть': 'Cerrar',
    'На главную': 'Ir al inicio',
    'Ошибка': 'Error',
    'Сохранение…': 'Guardando…',
    'Отправка…': 'Enviando…',
    'и': 'y',

    /* profile */
    'Мой аккаунт': 'Mi cuenta',
    'Аккаунт': 'Cuenta',
    'Пользователь': 'Usuario',
    'Дата регистрации': 'Miembro desde',
    'Дата визита': 'Primera visita',
    'Выйти': 'Cerrar sesión',
    'Гость · войдите для полного доступа': 'Invitado · inicia sesión para el acceso completo',
    '⭐ Получите 100 звёзд за регистрацию и 100 звёзд за привязку Telegram аккаунта бесплатно!': '⭐ Consigue 100 estrellas al registrarte y 100 más al vincular tu cuenta de Telegram, ¡gratis!',
    'Регистрация': 'Registrarse',
    'Войти': 'Iniciar sesión',
    'Ошибка загрузки данных пользователя': 'No se pudo cargar tu cuenta',

    /* balance */
    'Баланс': 'Saldo',
    'звёзд': 'estrellas',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Cada mensaje a un personaje cuesta al menos 10 estrellas',
    'Пополнить счёт': 'Recargar saldo',

    /* email */
    'Email': 'Correo electrónico',
    'Адрес': 'Dirección',
    'Статус': 'Estado',
    '✅ Подтверждён': '✅ Confirmado',
    '⏳ Не подтверждён': '⏳ Sin confirmar',
    '📬 Проверьте входящие и папку «Спам» — мы отправили письмо со ссылкой подтверждения. После подтверждения станет доступен сброс пароля по email.': '📬 Revisa tu bandeja de entrada y la carpeta de spam: te hemos enviado un enlace de confirmación. Una vez confirmado, podrás restablecer tu contraseña por correo.',
    '📨 Отправить письмо повторно': '📨 Reenviar el correo',
    '📨 Отправить повторно через {0} с': '📨 Reenviar en {0} s',
    '✏️ Изменить email': '✏️ Cambiar el correo',
    'Укажите email для подтверждения аккаунта и восстановления пароля.': 'Añade un correo para confirmar tu cuenta y recuperar tu contraseña.',
    'example@mail.ru': 'ejemplo@mail.com',
    'Текущий пароль для подтверждения': 'Contraseña actual para confirmar',
    '💾 Сохранить email': '💾 Guardar el correo',
    '📨 Email сохранён. Письмо с подтверждением отправлено — проверьте почту.': '📨 Correo guardado. El mensaje de confirmación va en camino: revisa tu bandeja de entrada.',
    'Ошибка при сохранении email': 'No se pudo guardar tu correo',
    '📨 Письмо отправлено повторно — проверьте почту (и папку «Спам»).': '📨 Correo reenviado: revisa tu bandeja de entrada (y la carpeta de spam).',
    'Ошибка при отправке письма': 'No se pudo enviar el correo',

    /* password */
    'Пароль': 'Contraseña',
    '✏️ Изменить пароль': '✏️ Cambiar la contraseña',
    'Текущий пароль': 'Contraseña actual',
    'Новый пароль': 'Nueva contraseña',
    'Подтвердить новый пароль': 'Confirmar la nueva contraseña',
    '💾 Сохранить пароль': '💾 Guardar la contraseña',
    'Новые пароли не совпадают': 'Las nuevas contraseñas no coinciden',
    'Пароль должен содержать минимум 6 символов': 'La contraseña debe tener al menos 6 caracteres',
    '✅ Пароль успешно изменён': '✅ Contraseña cambiada',
    'Ошибка при изменении пароля': 'No se pudo cambiar tu contraseña',

    /* telegram */
    'Код верификации': 'Código de verificación',
    'Скопируйте этот код и отправьте его в Telegram бот для подтверждения:': 'Copia este código y envíalo al bot de Telegram para confirmar:',
    'Скопировано': 'Copiado',
    'Копировать': 'Copiar',
    'Скопируйте код выше': 'Copia el código de arriba',
    'Откройте': 'Abre',
    'Отправьте код в личном сообщении': 'Envía el código por mensaje privado',
    'Получите подтверждение и 100 звёзд!': '¡Recibe tu confirmación y 100 estrellas!',
    'Привязка…': 'Vinculando…',
    '🔗 Привязать Telegram': '🔗 Vincular Telegram',
    '⭐ Подтвердите подписку на Telegram и получите 100 звёзд!': '⭐ Confirma tu suscripción a Telegram y recibe 100 estrellas.',
    '✅ Telegram привязан': '✅ Telegram vinculado',
    'Сбросить пароль: команда /change_password в боте': 'Restablecer la contraseña: comando /change_password en el bot',
    'Отвязать': 'Desvincular',
    'Привяжите аккаунт для восстановления пароля': 'Vincula tu cuenta para poder recuperar la contraseña',
    '⚠️ Убедитесь, что у вашего Telegram аккаунта есть публичный username в настройках': '⚠️ Asegúrate de que tu cuenta de Telegram tenga un nombre de usuario público en los ajustes',
    'Telegram аккаунт успешно привязан!': '¡Cuenta de Telegram vinculada!',
    'Ошибка привязки Telegram аккаунта': 'No se pudo vincular tu cuenta de Telegram',
    'Вы уверены, что хотите отвязать Telegram аккаунт? Вы не сможете сбрасывать пароль через Telegram.': '¿Seguro que quieres desvincular tu cuenta de Telegram? Ya no podrás restablecer tu contraseña por Telegram.',
    'Telegram аккаунт успешно отвязан!': '¡Cuenta de Telegram desvinculada!',
    'Ошибка отвязки Telegram аккаунта': 'No se pudo desvincular tu cuenta de Telegram',

    /* my novels */
    'Мои новеллы': 'Mis novelas',
    'У вас нет опубликованных новелл': 'No tienes novelas publicadas',
    'Всего ходов: {0}': 'Turnos totales: {0}',
    'Нет данных': 'Sin datos',
    'Месяц': 'Mes',
    'Ходы': 'Turnos',
    'Январь': 'Enero',
    'Февраль': 'Febrero',
    'Март': 'Marzo',
    'Апрель': 'Abril',
    'Май': 'Mayo',
    'Июнь': 'Junio',
    'Июль': 'Julio',
    'Август': 'Agosto',
    'Сентябрь': 'Septiembre',
    'Октябрь': 'Octubre',
    'Ноябрь': 'Noviembre',
    'Декабрь': 'Diciembre',

    /* admin */
    'Администрирование': 'Administración',
    'Жалобы пользователей': 'Reportes de usuarios',
    'Скрыть форму': 'Ocultar el formulario',
    'Опубликовать новость': 'Publicar noticia',
    'Заголовок': 'Título',
    'Slug (латиницей, напр. konkurs-iyun)': 'Slug (letras latinas, p. ej. contest-june)',
    'HTML-содержимое новости': 'Contenido HTML de la noticia',
    'Публикация...': 'Publicando...',
    'Опубликовать': 'Publicar',
    'Новость опубликована!': '¡Noticia publicada!',

    /* auth modal */
    'Создать аккаунт': 'Crear cuenta',
    '⭐ Получите 100 звёзд за регистрацию + ещё 100 за привязку Telegram = 200 БЕСПЛАТНЫХ звёзд!': '⭐ 100 estrellas por registrarte + 100 por vincular Telegram = ¡200 estrellas GRATIS!',
    'Зарегистрируйтесь, чтобы продолжить игру!': '¡Regístrate para seguir jugando!',
    'Имя пользователя': 'Nombre de usuario',
    'Подтвердить пароль': 'Confirmar la contraseña',
    'Нажимая кнопку «Создать аккаунт», вы принимаете': 'Al hacer clic en «Crear cuenta» aceptas nuestros',
    'Пользовательское соглашение': 'Términos de uso',
    'Политику конфиденциальности': 'Política de privacidad',
    'Уже есть аккаунт? Войдите': '¿Ya tienes cuenta? Inicia sesión',
    'Проверьте почту': 'Revisa tu correo',
    'Аккаунт создан! Мы отправили письмо со ссылкой для подтверждения email.': '¡Cuenta creada! Te hemos enviado un enlace para confirmar tu correo.',
    'После подтверждения вы сможете войти в аккаунт.': 'Una vez confirmado, podrás iniciar sesión.',
    'Вход в аккаунт': 'Iniciar sesión',
    'Чтобы продолжить, войдите в аккаунт или зарегистрируйтесь': 'Inicia sesión o crea una cuenta para continuar',
    'Имя пользователя или email': 'Nombre de usuario o correo',
    'Нужен аккаунт? Зарегистрируйтесь': '¿No tienes cuenta? Regístrate',
    'Забыли пароль?': '¿Olvidaste tu contraseña?',
    'Восстановление пароля': 'Recuperar la contraseña',
    'Введите ваше имя пользователя или email. Если аккаунт найден и email подтверждён — мы отправим ссылку для сброса пароля.': 'Introduce tu nombre de usuario o tu correo. Si la cuenta existe y su correo está confirmado, te enviaremos un enlace para restablecer la contraseña.',
    'Отправить письмо': 'Enviar el correo',
    'Вернуться ко входу': 'Volver al inicio de sesión',
    'Письмо отправлено': 'Correo enviado',
    'Письмо со ссылкой для сброса пароля отправлено на ваш email.': 'Te hemos enviado un enlace para restablecer la contraseña.',
    'Ссылка действительна 1 час.': 'El enlace es válido durante 1 hora.',
    'Пожалуйста, заполните все поля': 'Rellena todos los campos',
    'Пароли не совпадают': 'Las contraseñas no coinciden',
    'Имя пользователя может содержать только английские буквы, цифры и нижнее подчёркивание': 'El nombre de usuario solo puede contener letras latinas, números y guiones bajos',
    'Введите корректный email': 'Introduce una dirección de correo válida',
    'Аккаунт создан! Проверьте почту для подтверждения.': '¡Cuenta creada! Revisa tu correo para confirmarla.',
    'Вход выполнен успешно!': '¡Sesión iniciada!',
    'Ошибка регистрации': 'Error al registrarse',
    'Ошибка входа': 'Error al iniciar sesión',
    'Введите имя пользователя или email': 'Introduce tu nombre de usuario o tu correo',

    /* reset password page */
    'Пожалуйста, заполните оба поля.': 'Rellena ambos campos.',
    'Пароли не совпадают.': 'Las contraseñas no coinciden.',
    'Пароль должен содержать минимум 6 символов.': 'La contraseña debe tener al menos 6 caracteres.',
    'Не удалось сбросить пароль.': 'No se pudo restablecer la contraseña.',
    'Пароль изменён!': '¡Contraseña cambiada!',
    'Теперь вы можете войти с новым паролем.': 'Ya puedes iniciar sesión con tu nueva contraseña.',
    'Введите новый пароль для вашего аккаунта.': 'Elige una nueva contraseña para tu cuenta.',
    'Ссылка недействительна. Запросите новую.': 'Este enlace no es válido. Solicita uno nuevo.',
    'Сохранить пароль': 'Guardar la contraseña',

    /* confirm email page */
    'Токен подтверждения отсутствует.': 'Falta el token de confirmación.',
    'Email успешно подтверждён!': '¡Tu correo ha sido confirmado!',
    'Аккаунт создан! Подтвердите email по ссылке из письма и получите {0} звёзд.': '¡Cuenta creada! Confirma tu correo con el enlace que te enviamos y consigue {0} estrellas.',
    '📧 Подтвердите email после регистрации и получите {0} бесплатных звёзд!': '📧 ¡Confirma tu correo después de registrarte y consigue {0} estrellas gratis!',
    '📧 Новый игрок? Зарегистрируйтесь и подтвердите email — получите {0} звёзд бесплатно!': '📧 ¿Eres nuevo? Regístrate y confirma tu correo: ¡{0} estrellas gratis!',
    'Вам начислено {0} звёзд за подтверждение email.': 'Se han añadido {0} estrellas a tu saldo por confirmar tu correo.',
    'Не удалось подтвердить email.': 'No se pudo confirmar tu correo.',
    'Ошибка соединения. Попробуйте позже.': 'Error de conexión. Inténtalo más tarde.',
    'Подтверждаем ваш email…': 'Confirmando tu correo…',
    'Email подтверждён!': '¡Correo confirmado!',
    'Перейти на главную': 'Ir al inicio',
  },

  italian: {
    "Скидка по подписке −{0}% выгоднее — применяется она": "Lo sconto abbonamento −{0}% è migliore: viene applicato quello",
    " · скидка {0}%": " · {0}% di sconto",
    "Подписка «{0}»": "Abbonamento «{0}»",
    /* payment page: checkout details placeholder */
    'Оплата и обработка платежей': 'Pagamento ed elaborazione',
    'Платёжный провайдер': 'Fornitore di pagamento',
    'Уточняется': 'Da confermare',
    'Способы оплаты': 'Metodi di pagamento',
    'Валюта': 'Valuta',
    'Доллар США (USD)': 'Dollaro statunitense (USD)',
    'Зачисление звёзд': 'Accredito delle Stelle',
    'Сразу после подтверждения платежа': 'Subito dopo la conferma del pagamento',
    'Возврат': 'Rimborsi',
    'Мы не храним данные банковских карт: при запуске оплаты они будут обрабатываться платёжным провайдером на его стороне.': "Non conserviamo i dati delle carte: all'attivazione dei pagamenti saranno trattati dal fornitore di pagamento sui suoi sistemi.",
    '⭐ Получите 100 звёзд за регистрацию бесплатно!': '⭐ Ottieni 100 stelle gratis solo per esserti registrato!',
    /* general */
    'Загрузка…': 'Caricamento…',
    'Отмена': 'Annulla',
    'Отменить': 'Annulla',
    'Закрыть': 'Chiudi',
    'На главную': 'Vai alla home',
    'Ошибка': 'Errore',
    'Сохранение…': 'Salvataggio…',
    'Отправка…': 'Invio…',
    'и': 'e',

    /* profile */
    'Мой аккаунт': 'Il mio account',
    'Аккаунт': 'Account',
    'Пользователь': 'Nome utente',
    'Дата регистрации': 'Iscritto dal',
    'Дата визита': 'Prima visita',
    'Выйти': 'Esci',
    'Гость · войдите для полного доступа': "Ospite · accedi per l'accesso completo",
    '⭐ Получите 100 звёзд за регистрацию и 100 звёзд за привязку Telegram аккаунта бесплатно!': '⭐ Ricevi 100 stelle per la registrazione e altre 100 collegando il tuo account Telegram, gratis!',
    'Регистрация': 'Registrati',
    'Войти': 'Accedi',
    'Ошибка загрузки данных пользователя': 'Impossibile caricare il tuo account',

    /* balance */
    'Баланс': 'Saldo',
    'звёзд': 'stelle',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Ogni messaggio a un personaggio costa almeno 10 stelle',
    'Пополнить счёт': 'Ricarica il saldo',

    /* email */
    'Email': 'Email',
    'Адрес': 'Indirizzo',
    'Статус': 'Stato',
    '✅ Подтверждён': '✅ Confermata',
    '⏳ Не подтверждён': '⏳ Non confermata',
    '📬 Проверьте входящие и папку «Спам» — мы отправили письмо со ссылкой подтверждения. После подтверждения станет доступен сброс пароля по email.': '📬 Controlla la posta in arrivo e la cartella spam — ti abbiamo inviato un link di conferma. Dopo la conferma potrai reimpostare la password via email.',
    '📨 Отправить письмо повторно': "📨 Invia di nuovo l'email",
    '📨 Отправить повторно через {0} с': '📨 Invia di nuovo tra {0} s',
    '✏️ Изменить email': "✏️ Modifica l'email",
    'Укажите email для подтверждения аккаунта и восстановления пароля.': 'Aggiungi un indirizzo email per confermare il tuo account e recuperare la password.',
    'example@mail.ru': 'esempio@mail.com',
    'Текущий пароль для подтверждения': 'Password attuale per confermare',
    '💾 Сохранить email': "💾 Salva l'email",
    '📨 Email сохранён. Письмо с подтверждением отправлено — проверьте почту.': '📨 Email salvata. Il messaggio di conferma è in arrivo — controlla la posta.',
    'Ошибка при сохранении email': "Impossibile salvare la tua email",
    '📨 Письмо отправлено повторно — проверьте почту (и папку «Спам»).': '📨 Email inviata di nuovo — controlla la posta (e la cartella spam).',
    'Ошибка при отправке письма': "Impossibile inviare l'email",

    /* password */
    'Пароль': 'Password',
    '✏️ Изменить пароль': '✏️ Cambia la password',
    'Текущий пароль': 'Password attuale',
    'Новый пароль': 'Nuova password',
    'Подтвердить новый пароль': 'Conferma la nuova password',
    '💾 Сохранить пароль': '💾 Salva la password',
    'Новые пароли не совпадают': 'Le nuove password non coincidono',
    'Пароль должен содержать минимум 6 символов': 'La password deve contenere almeno 6 caratteri',
    '✅ Пароль успешно изменён': '✅ Password cambiata',
    'Ошибка при изменении пароля': 'Impossibile cambiare la tua password',

    /* telegram */
    'Код верификации': 'Codice di verifica',
    'Скопируйте этот код и отправьте его в Telegram бот для подтверждения:': 'Copia questo codice e invialo al bot Telegram per confermare:',
    'Скопировано': 'Copiato',
    'Копировать': 'Copia',
    'Скопируйте код выше': 'Copia il codice qui sopra',
    'Откройте': 'Apri',
    'Отправьте код в личном сообщении': 'Invia il codice in un messaggio privato',
    'Получите подтверждение и 100 звёзд!': 'Ricevi la conferma e 100 stelle!',
    'Привязка…': 'Collegamento…',
    '🔗 Привязать Telegram': '🔗 Collega Telegram',
    '⭐ Подтвердите подписку на Telegram и получите 100 звёзд!': '⭐ Conferma la tua iscrizione a Telegram e ricevi 100 stelle!',
    '✅ Telegram привязан': '✅ Telegram collegato',
    'Сбросить пароль: команда /change_password в боте': 'Reimposta la password: comando /change_password nel bot',
    'Отвязать': 'Scollega',
    'Привяжите аккаунт для восстановления пароля': 'Collega il tuo account per poter recuperare la password',
    '⚠️ Убедитесь, что у вашего Telegram аккаунта есть публичный username в настройках': '⚠️ Assicurati che il tuo account Telegram abbia un nome utente pubblico nelle impostazioni',
    'Telegram аккаунт успешно привязан!': 'Account Telegram collegato!',
    'Ошибка привязки Telegram аккаунта': 'Impossibile collegare il tuo account Telegram',
    'Вы уверены, что хотите отвязать Telegram аккаунт? Вы не сможете сбрасывать пароль через Telegram.': 'Vuoi davvero scollegare il tuo account Telegram? Non potrai più reimpostare la password tramite Telegram.',
    'Telegram аккаунт успешно отвязан!': 'Account Telegram scollegato!',
    'Ошибка отвязки Telegram аккаунта': 'Impossibile scollegare il tuo account Telegram',

    /* my novels */
    'Мои новеллы': 'Le mie novel',
    'У вас нет опубликованных новелл': 'Non hai novel pubblicate',
    'Всего ходов: {0}': 'Turni totali: {0}',
    'Нет данных': 'Nessun dato',
    'Месяц': 'Mese',
    'Ходы': 'Turni',
    'Январь': 'Gennaio',
    'Февраль': 'Febbraio',
    'Март': 'Marzo',
    'Апрель': 'Aprile',
    'Май': 'Maggio',
    'Июнь': 'Giugno',
    'Июль': 'Luglio',
    'Август': 'Agosto',
    'Сентябрь': 'Settembre',
    'Октябрь': 'Ottobre',
    'Ноябрь': 'Novembre',
    'Декабрь': 'Dicembre',

    /* admin */
    'Администрирование': 'Amministrazione',
    'Жалобы пользователей': 'Segnalazioni degli utenti',
    'Скрыть форму': 'Nascondi il modulo',
    'Опубликовать новость': 'Pubblica una notizia',
    'Заголовок': 'Titolo',
    'Slug (латиницей, напр. konkurs-iyun)': 'Slug (lettere latine, es. contest-june)',
    'HTML-содержимое новости': 'Contenuto HTML della notizia',
    'Публикация...': 'Pubblicazione...',
    'Опубликовать': 'Pubblica',
    'Новость опубликована!': 'Notizia pubblicata!',

    /* auth modal */
    'Создать аккаунт': 'Crea account',
    '⭐ Получите 100 звёзд за регистрацию + ещё 100 за привязку Telegram = 200 БЕСПЛАТНЫХ звёзд!': '⭐ 100 stelle per la registrazione + 100 per Telegram = 200 stelle GRATIS!',
    'Зарегистрируйтесь, чтобы продолжить игру!': 'Registrati per continuare a giocare!',
    'Имя пользователя': 'Nome utente',
    'Подтвердить пароль': 'Conferma la password',
    'Нажимая кнопку «Создать аккаунт», вы принимаете': 'Cliccando su «Crea account» accetti i nostri',
    'Пользовательское соглашение': 'Termini di servizio',
    'Политику конфиденциальности': 'Informativa sulla privacy',
    'Уже есть аккаунт? Войдите': 'Hai già un account? Accedi',
    'Проверьте почту': 'Controlla la posta',
    'Аккаунт создан! Мы отправили письмо со ссылкой для подтверждения email.': 'Account creato! Ti abbiamo inviato un link per confermare la tua email.',
    'После подтверждения вы сможете войти в аккаунт.': 'Dopo la conferma potrai accedere al tuo account.',
    'Вход в аккаунт': 'Accedi',
    'Чтобы продолжить, войдите в аккаунт или зарегистрируйтесь': 'Accedi o registrati per continuare',
    'Имя пользователя или email': 'Nome utente o email',
    'Нужен аккаунт? Зарегистрируйтесь': 'Non hai un account? Registrati',
    'Забыли пароль?': 'Password dimenticata?',
    'Восстановление пароля': 'Recupero della password',
    'Введите ваше имя пользователя или email. Если аккаунт найден и email подтверждён — мы отправим ссылку для сброса пароля.': "Inserisci il tuo nome utente o la tua email. Se l'account esiste e la sua email è confermata, ti invieremo un link per reimpostare la password.",
    'Отправить письмо': "Invia l'email",
    'Вернуться ко входу': "Torna all'accesso",
    'Письмо отправлено': 'Email inviata',
    'Письмо со ссылкой для сброса пароля отправлено на ваш email.': 'Ti abbiamo inviato un link per reimpostare la password.',
    'Ссылка действительна 1 час.': 'Il link è valido per 1 ora.',
    'Пожалуйста, заполните все поля': 'Compila tutti i campi',
    'Пароли не совпадают': 'Le password non coincidono',
    'Имя пользователя может содержать только английские буквы, цифры и нижнее подчёркивание': 'Il nome utente può contenere solo lettere latine, numeri e trattini bassi',
    'Введите корректный email': 'Inserisci un indirizzo email valido',
    'Аккаунт создан! Проверьте почту для подтверждения.': 'Account creato! Controlla la posta per confermarlo.',
    'Вход выполнен успешно!': 'Accesso effettuato!',
    'Ошибка регистрации': 'Registrazione non riuscita',
    'Ошибка входа': 'Accesso non riuscito',
    'Введите имя пользователя или email': 'Inserisci il tuo nome utente o la tua email',

    /* reset password page */
    'Пожалуйста, заполните оба поля.': 'Compila entrambi i campi.',
    'Пароли не совпадают.': 'Le password non coincidono.',
    'Пароль должен содержать минимум 6 символов.': 'La password deve contenere almeno 6 caratteri.',
    'Не удалось сбросить пароль.': 'Impossibile reimpostare la password.',
    'Пароль изменён!': 'Password cambiata!',
    'Теперь вы можете войти с новым паролем.': 'Ora puoi accedere con la tua nuova password.',
    'Введите новый пароль для вашего аккаунта.': 'Scegli una nuova password per il tuo account.',
    'Ссылка недействительна. Запросите новую.': 'Questo link non è valido. Richiedine uno nuovo.',
    'Сохранить пароль': 'Salva la password',

    /* confirm email page */
    'Токен подтверждения отсутствует.': 'Manca il token di conferma.',
    'Email успешно подтверждён!': 'La tua email è stata confermata!',
    'Аккаунт создан! Подтвердите email по ссылке из письма и получите {0} звёзд.': 'Account creato! Conferma la tua email con il link che ti abbiamo inviato e ricevi {0} stelle.',
    '📧 Подтвердите email после регистрации и получите {0} бесплатных звёзд!': '📧 Conferma la tua email dopo la registrazione e ricevi {0} stelle gratis!',
    '📧 Новый игрок? Зарегистрируйтесь и подтвердите email — получите {0} звёзд бесплатно!': '📧 Sei nuovo? Registrati e conferma la tua email: {0} stelle gratis!',
    'Вам начислено {0} звёзд за подтверждение email.': 'Ti sono state accreditate {0} stelle per aver confermato la tua email.',
    'Не удалось подтвердить email.': 'Impossibile confermare la tua email.',
    'Ошибка соединения. Попробуйте позже.': 'Errore di connessione. Riprova più tardi.',
    'Подтверждаем ваш email…': 'Stiamo confermando la tua email…',
    'Email подтверждён!': 'Email confermata!',
    'Перейти на главную': 'Vai alla home',
  },

  polish: {
    "Скидка по подписке −{0}% выгоднее — применяется она": "Zniżka abonamentowa −{0}% jest lepsza — to ona obowiązuje",
    " · скидка {0}%": " · {0}% zniżki",
    "Подписка «{0}»": "Subskrypcja „{0}”",
    /* payment page: checkout details placeholder */
    'Оплата и обработка платежей': 'Płatność i jej obsługa',
    'Платёжный провайдер': 'Dostawca płatności',
    'Уточняется': 'Do ustalenia',
    'Способы оплаты': 'Metody płatności',
    'Валюта': 'Waluta',
    'Доллар США (USD)': 'Dolar amerykański (USD)',
    'Зачисление звёзд': 'Naliczenie Gwiazdek',
    'Сразу после подтверждения платежа': 'Natychmiast po potwierdzeniu płatności',
    'Возврат': 'Zwroty',
    'Мы не храним данные банковских карт: при запуске оплаты они будут обрабатываться платёжным провайдером на его стороне.': 'Nie przechowujemy danych kart: po uruchomieniu płatności będą one obsługiwane przez dostawcę płatności po jego stronie.',
    '⭐ Получите 100 звёзд за регистрацию бесплатно!': '⭐ Odbierz 100 darmowych gwiazdek już za rejestrację!',
    /* general */
    'Загрузка…': 'Wczytywanie…',
    'Отмена': 'Anuluj',
    'Отменить': 'Anuluj',
    'Закрыть': 'Zamknij',
    'На главную': 'Strona główna',
    'Ошибка': 'Błąd',
    'Сохранение…': 'Zapisywanie…',
    'Отправка…': 'Wysyłanie…',
    'и': 'i',

    /* profile */
    'Мой аккаунт': 'Moje konto',
    'Аккаунт': 'Konto',
    'Пользователь': 'Nazwa użytkownika',
    'Дата регистрации': 'Data rejestracji',
    'Дата визита': 'Data wizyty',
    'Выйти': 'Wyloguj się',
    'Гость · войдите для полного доступа': 'Gość · zaloguj się, aby uzyskać pełny dostęp',
    '⭐ Получите 100 звёзд за регистрацию и 100 звёзд за привязку Telegram аккаунта бесплатно!': '⭐ Odbierz 100 gwiazdek za rejestrację i 100 za połączenie konta Telegram — za darmo!',
    'Регистрация': 'Zarejestruj się',
    'Войти': 'Zaloguj się',
    'Ошибка загрузки данных пользователя': 'Nie udało się wczytać Twojego konta',

    /* balance */
    'Баланс': 'Saldo',
    'звёзд': 'gwiazdek',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Każda wiadomość do postaci kosztuje co najmniej 10 gwiazdek',
    'Пополнить счёт': 'Doładuj konto',

    /* email */
    'Email': 'E-mail',
    'Адрес': 'Adres',
    'Статус': 'Status',
    '✅ Подтверждён': '✅ Potwierdzony',
    '⏳ Не подтверждён': '⏳ Niepotwierdzony',
    '📬 Проверьте входящие и папку «Спам» — мы отправили письмо со ссылкой подтверждения. После подтверждения станет доступен сброс пароля по email.': '📬 Sprawdź skrzynkę odbiorczą i folder spam — wysłaliśmy Ci link potwierdzający. Po potwierdzeniu będziesz mieć dostęp do resetu hasła przez e-mail.',
    '📨 Отправить письмо повторно': '📨 Wyślij e-mail ponownie',
    '📨 Отправить повторно через {0} с': '📨 Wyślij ponownie za {0} s',
    '✏️ Изменить email': '✏️ Zmień e-mail',
    'Укажите email для подтверждения аккаунта и восстановления пароля.': 'Podaj adres e-mail, aby potwierdzić konto i móc odzyskać hasło.',
    'example@mail.ru': 'przyklad@mail.com',
    'Текущий пароль для подтверждения': 'Obecne hasło, aby potwierdzić',
    '💾 Сохранить email': '💾 Zapisz e-mail',
    '📨 Email сохранён. Письмо с подтверждением отправлено — проверьте почту.': '📨 E-mail zapisany. Wiadomość z potwierdzeniem jest w drodze — sprawdź skrzynkę.',
    'Ошибка при сохранении email': 'Nie udało się zapisać Twojego e-maila',
    '📨 Письмо отправлено повторно — проверьте почту (и папку «Спам»).': '📨 E-mail wysłany ponownie — sprawdź skrzynkę (i folder spam).',
    'Ошибка при отправке письма': 'Nie udało się wysłać wiadomości',

    /* password */
    'Пароль': 'Hasło',
    '✏️ Изменить пароль': '✏️ Zmień hasło',
    'Текущий пароль': 'Obecne hasło',
    'Новый пароль': 'Nowe hasło',
    'Подтвердить новый пароль': 'Potwierdź nowe hasło',
    '💾 Сохранить пароль': '💾 Zapisz hasło',
    'Новые пароли не совпадают': 'Nowe hasła nie są takie same',
    'Пароль должен содержать минимум 6 символов': 'Hasło musi mieć co najmniej 6 znaków',
    '✅ Пароль успешно изменён': '✅ Hasło zmienione',
    'Ошибка при изменении пароля': 'Nie udało się zmienić hasła',

    /* telegram */
    'Код верификации': 'Kod weryfikacyjny',
    'Скопируйте этот код и отправьте его в Telegram бот для подтверждения:': 'Skopiuj ten kod i wyślij go do bota na Telegramie, aby potwierdzić:',
    'Скопировано': 'Skopiowano',
    'Копировать': 'Kopiuj',
    'Скопируйте код выше': 'Skopiuj kod powyżej',
    'Откройте': 'Otwórz',
    'Отправьте код в личном сообщении': 'Wyślij kod w wiadomości prywatnej',
    'Получите подтверждение и 100 звёзд!': 'Odbierz potwierdzenie i 100 gwiazdek!',
    'Привязка…': 'Łączenie…',
    '🔗 Привязать Telegram': '🔗 Połącz Telegram',
    '⭐ Подтвердите подписку на Telegram и получите 100 звёзд!': '⭐ Potwierdź subskrypcję na Telegramie i odbierz 100 gwiazdek!',
    '✅ Telegram привязан': '✅ Telegram połączony',
    'Сбросить пароль: команда /change_password в боте': 'Reset hasła: komenda /change_password w bocie',
    'Отвязать': 'Odłącz',
    'Привяжите аккаунт для восстановления пароля': 'Połącz konto, aby móc odzyskać hasło',
    '⚠️ Убедитесь, что у вашего Telegram аккаунта есть публичный username в настройках': '⚠️ Upewnij się, że Twoje konto Telegram ma publiczną nazwę użytkownika w ustawieniach',
    'Telegram аккаунт успешно привязан!': 'Konto Telegram połączone!',
    'Ошибка привязки Telegram аккаунта': 'Nie udało się połączyć konta Telegram',
    'Вы уверены, что хотите отвязать Telegram аккаунт? Вы не сможете сбрасывать пароль через Telegram.': 'Na pewno chcesz odłączyć konto Telegram? Nie będzie można resetować hasła przez Telegram.',
    'Telegram аккаунт успешно отвязан!': 'Konto Telegram odłączone!',
    'Ошибка отвязки Telegram аккаунта': 'Nie udało się odłączyć konta Telegram',

    /* my novels */
    'Мои новеллы': 'Moje powieści',
    'У вас нет опубликованных новелл': 'Nie masz opublikowanych powieści',
    'Всего ходов: {0}': 'Łącznie tur: {0}',
    'Нет данных': 'Brak danych',
    'Месяц': 'Miesiąc',
    'Ходы': 'Tury',
    'Январь': 'Styczeń',
    'Февраль': 'Luty',
    'Март': 'Marzec',
    'Апрель': 'Kwiecień',
    'Май': 'Maj',
    'Июнь': 'Czerwiec',
    'Июль': 'Lipiec',
    'Август': 'Sierpień',
    'Сентябрь': 'Wrzesień',
    'Октябрь': 'Październik',
    'Ноябрь': 'Listopad',
    'Декабрь': 'Grudzień',

    /* admin */
    'Администрирование': 'Administracja',
    'Жалобы пользователей': 'Zgłoszenia użytkowników',
    'Скрыть форму': 'Ukryj formularz',
    'Опубликовать новость': 'Opublikuj wiadomość',
    'Заголовок': 'Tytuł',
    'Slug (латиницей, напр. konkurs-iyun)': 'Slug (litery łacińskie, np. contest-june)',
    'HTML-содержимое новости': 'Treść HTML wiadomości',
    'Публикация...': 'Publikowanie...',
    'Опубликовать': 'Opublikuj',
    'Новость опубликована!': 'Wiadomość opublikowana!',

    /* auth modal */
    'Создать аккаунт': 'Utwórz konto',
    '⭐ Получите 100 звёзд за регистрацию + ещё 100 за привязку Telegram = 200 БЕСПЛАТНЫХ звёзд!': '⭐ 100 gwiazdek za rejestrację + 100 za Telegram = 200 DARMOWYCH gwiazdek!',
    'Зарегистрируйтесь, чтобы продолжить игру!': 'Zarejestruj się, aby grać dalej!',
    'Имя пользователя': 'Nazwa użytkownika',
    'Подтвердить пароль': 'Potwierdź hasło',
    'Нажимая кнопку «Создать аккаунт», вы принимаете': 'Klikając „Utwórz konto”, akceptujesz',
    'Пользовательское соглашение': 'Regulamin',
    'Политику конфиденциальности': 'Politykę prywatności',
    'Уже есть аккаунт? Войдите': 'Masz już konto? Zaloguj się',
    'Проверьте почту': 'Sprawdź skrzynkę',
    'Аккаунт создан! Мы отправили письмо со ссылкой для подтверждения email.': 'Konto utworzone! Wysłaliśmy Ci link potwierdzający adres e-mail.',
    'После подтверждения вы сможете войти в аккаунт.': 'Po potwierdzeniu będziesz mieć możliwość zalogowania się.',
    'Вход в аккаунт': 'Logowanie',
    'Чтобы продолжить, войдите в аккаунт или зарегистрируйтесь': 'Zaloguj się lub załóż konto, aby kontynuować',
    'Имя пользователя или email': 'Nazwa użytkownika lub e-mail',
    'Нужен аккаунт? Зарегистрируйтесь': 'Nie masz konta? Zarejestruj się',
    'Забыли пароль?': 'Nie pamiętasz hasła?',
    'Восстановление пароля': 'Odzyskiwanie hasła',
    'Введите ваше имя пользователя или email. Если аккаунт найден и email подтверждён — мы отправим ссылку для сброса пароля.': 'Podaj swoją nazwę użytkownika lub adres e-mail. Jeśli konto istnieje, a jego e-mail jest potwierdzony, wyślemy link do zresetowania hasła.',
    'Отправить письмо': 'Wyślij e-mail',
    'Вернуться ко входу': 'Wróć do logowania',
    'Письмо отправлено': 'E-mail wysłany',
    'Письмо со ссылкой для сброса пароля отправлено на ваш email.': 'Wysłaliśmy na Twój adres e-mail link do zresetowania hasła.',
    'Ссылка действительна 1 час.': 'Link jest ważny przez 1 godzinę.',
    'Пожалуйста, заполните все поля': 'Wypełnij wszystkie pola',
    'Пароли не совпадают': 'Hasła nie są takie same',
    'Имя пользователя может содержать только английские буквы, цифры и нижнее подчёркивание': 'Nazwa użytkownika może zawierać tylko litery łacińskie, cyfry i podkreślenia',
    'Введите корректный email': 'Podaj poprawny adres e-mail',
    'Аккаунт создан! Проверьте почту для подтверждения.': 'Konto utworzone! Sprawdź skrzynkę, aby je potwierdzić.',
    'Вход выполнен успешно!': 'Zalogowano pomyślnie!',
    'Ошибка регистрации': 'Rejestracja nie powiodła się',
    'Ошибка входа': 'Logowanie nie powiodło się',
    'Введите имя пользователя или email': 'Podaj nazwę użytkownika lub adres e-mail',

    /* reset password page */
    'Пожалуйста, заполните оба поля.': 'Wypełnij oba pola.',
    'Пароли не совпадают.': 'Hasła nie są takie same.',
    'Пароль должен содержать минимум 6 символов.': 'Hasło musi mieć co najmniej 6 znaków.',
    'Не удалось сбросить пароль.': 'Nie udało się zresetować hasła.',
    'Пароль изменён!': 'Hasło zmienione!',
    'Теперь вы можете войти с новым паролем.': 'Możesz teraz zalogować się nowym hasłem.',
    'Введите новый пароль для вашего аккаунта.': 'Wybierz nowe hasło do swojego konta.',
    'Ссылка недействительна. Запросите новую.': 'Ten link jest nieprawidłowy. Poproś o nowy.',
    'Сохранить пароль': 'Zapisz hasło',

    /* confirm email page */
    'Токен подтверждения отсутствует.': 'Brak tokenu potwierdzającego.',
    'Email успешно подтверждён!': 'Twój adres e-mail został potwierdzony!',
    'Аккаунт создан! Подтвердите email по ссылке из письма и получите {0} звёзд.': 'Konto utworzone! Potwierdź e-mail linkiem z wiadomości i odbierz {0} gwiazdek.',
    '📧 Подтвердите email после регистрации и получите {0} бесплатных звёзд!': '📧 Potwierdź e-mail po rejestracji i odbierz {0} darmowych gwiazdek!',
    '📧 Новый игрок? Зарегистрируйтесь и подтвердите email — получите {0} звёзд бесплатно!': '📧 Jesteś tu nowy? Zarejestruj się i potwierdź e-mail — {0} gwiazdek za darmo!',
    'Вам начислено {0} звёзд за подтверждение email.': 'Dodaliśmy {0} gwiazdek do Twojego salda za potwierdzenie e-maila.',
    'Не удалось подтвердить email.': 'Nie udało się potwierdzić adresu e-mail.',
    'Ошибка соединения. Попробуйте позже.': 'Błąd połączenia. Spróbuj ponownie później.',
    'Подтверждаем ваш email…': 'Potwierdzamy Twój adres e-mail…',
    'Email подтверждён!': 'E-mail potwierdzony!',
    'Перейти на главную': 'Przejdź na stronę główną',
  },

  portuguese: {
    "Скидка по подписке −{0}% выгоднее — применяется она": "O desconto da assinatura de −{0}% é maior — ele é que vale",
    " · скидка {0}%": " · {0}% de desconto",
    "Подписка «{0}»": "Assinatura “{0}”",
    /* payment page: checkout details placeholder */
    'Оплата и обработка платежей': 'Pagamento e processamento',
    'Платёжный провайдер': 'Provedor de pagamento',
    'Уточняется': 'A confirmar',
    'Способы оплаты': 'Formas de pagamento',
    'Валюта': 'Moeda',
    'Доллар США (USD)': 'Dólar americano (USD)',
    'Зачисление звёзд': 'Crédito das estrelas',
    'Сразу после подтверждения платежа': 'Logo após a confirmação do pagamento',
    'Возврат': 'Reembolsos',
    'Мы не храним данные банковских карт: при запуске оплаты они будут обрабатываться платёжным провайдером на его стороне.': 'Não armazenamos dados de cartão: quando os pagamentos forem ativados, eles serão processados pelo provedor de pagamento, do lado dele.',
    '⭐ Получите 100 звёзд за регистрацию бесплатно!': '⭐ Ganhe 100 estrelas grátis só por se cadastrar!',
    /* general */
    'Загрузка…': 'Carregando…',
    'Отмена': 'Cancelar',
    'Отменить': 'Cancelar',
    'Закрыть': 'Fechar',
    'На главную': 'Início',
    'Ошибка': 'Erro',
    'Сохранение…': 'Salvando…',
    'Отправка…': 'Enviando…',
    'и': 'e',

    /* profile */
    'Мой аккаунт': 'Minha conta',
    'Аккаунт': 'Conta',
    'Пользователь': 'Nome de usuário',
    'Дата регистрации': 'Membro desde',
    'Дата визита': 'Primeira visita',
    'Выйти': 'Sair',
    'Гость · войдите для полного доступа': 'Visitante · entre para ter acesso completo',
    '⭐ Получите 100 звёзд за регистрацию и 100 звёзд за привязку Telegram аккаунта бесплатно!': '⭐ Ganhe 100 estrelas grátis ao se cadastrar e mais 100 ao vincular sua conta do Telegram!',
    'Регистрация': 'Cadastrar',
    'Войти': 'Entrar',
    'Ошибка загрузки данных пользователя': 'Não foi possível carregar sua conta',

    /* balance */
    'Баланс': 'Saldo',
    'звёзд': 'estrelas',
    '💬 Каждое сообщение персонажам стоит минимум 10 звёзд': '💬 Cada mensagem para um personagem custa no mínimo 10 estrelas',
    'Пополнить счёт': 'Recarregar saldo',

    /* email */
    'Email': 'E-mail',
    'Адрес': 'Endereço',
    'Статус': 'Status',
    '✅ Подтверждён': '✅ Confirmado',
    '⏳ Не подтверждён': '⏳ Não confirmado',
    '📬 Проверьте входящие и папку «Спам» — мы отправили письмо со ссылкой подтверждения. После подтверждения станет доступен сброс пароля по email.': '📬 Confira sua caixa de entrada e a pasta de spam — enviamos um link de confirmação. Depois de confirmar, você poderá redefinir sua senha por e-mail.',
    '📨 Отправить письмо повторно': '📨 Reenviar e-mail',
    '📨 Отправить повторно через {0} с': '📨 Reenviar em {0}s',
    '✏️ Изменить email': '✏️ Alterar e-mail',
    'Укажите email для подтверждения аккаунта и восстановления пароля.': 'Adicione um e-mail para confirmar sua conta e recuperar sua senha.',
    'example@mail.ru': 'exemplo@email.com',
    'Текущий пароль для подтверждения': 'Senha atual para confirmar',
    '💾 Сохранить email': '💾 Salvar e-mail',
    '📨 Email сохранён. Письмо с подтверждением отправлено — проверьте почту.': '📨 E-mail salvo. Uma mensagem de confirmação está a caminho — confira sua caixa de entrada.',
    'Ошибка при сохранении email': 'Não foi possível salvar seu e-mail',
    '📨 Письмо отправлено повторно — проверьте почту (и папку «Спам»).': '📨 E-mail reenviado — confira sua caixa de entrada (e a pasta de spam).',
    'Ошибка при отправке письма': 'Não foi possível enviar o e-mail',

    /* password */
    'Пароль': 'Senha',
    '✏️ Изменить пароль': '✏️ Alterar senha',
    'Текущий пароль': 'Senha atual',
    'Новый пароль': 'Nova senha',
    'Подтвердить новый пароль': 'Confirmar nova senha',
    '💾 Сохранить пароль': '💾 Salvar senha',
    'Новые пароли не совпадают': 'As novas senhas não coincidem',
    'Пароль должен содержать минимум 6 символов': 'A senha deve ter pelo menos 6 caracteres',
    '✅ Пароль успешно изменён': '✅ Senha alterada',
    'Ошибка при изменении пароля': 'Não foi possível alterar sua senha',

    /* telegram */
    'Код верификации': 'Código de verificação',
    'Скопируйте этот код и отправьте его в Telegram бот для подтверждения:': 'Copie este código e envie para o bot do Telegram para confirmar:',
    'Скопировано': 'Copiado',
    'Копировать': 'Copiar',
    'Скопируйте код выше': 'Copie o código acima',
    'Откройте': 'Abra',
    'Отправьте код в личном сообщении': 'Envie o código em uma mensagem privada',
    'Получите подтверждение и 100 звёзд!': 'Receba a confirmação e 100 estrelas!',
    'Привязка…': 'Vinculando…',
    '🔗 Привязать Telegram': '🔗 Vincular Telegram',
    '⭐ Подтвердите подписку на Telegram и получите 100 звёзд!': '⭐ Confirme que você segue nosso Telegram e ganhe 100 estrelas!',
    '✅ Telegram привязан': '✅ Telegram vinculado',
    'Сбросить пароль: команда /change_password в боте': 'Redefinir senha: comando /change_password no bot',
    'Отвязать': 'Desvincular',
    'Привяжите аккаунт для восстановления пароля': 'Vincule sua conta para recuperar a senha',
    '⚠️ Убедитесь, что у вашего Telegram аккаунта есть публичный username в настройках': '⚠️ Verifique se sua conta do Telegram tem um nome de usuário público nas configurações',
    'Telegram аккаунт успешно привязан!': 'Conta do Telegram vinculada!',
    'Ошибка привязки Telegram аккаунта': 'Não foi possível vincular sua conta do Telegram',
    'Вы уверены, что хотите отвязать Telegram аккаунт? Вы не сможете сбрасывать пароль через Telegram.': 'Desvincular sua conta do Telegram? Você não poderá mais redefinir sua senha pelo Telegram.',
    'Telegram аккаунт успешно отвязан!': 'Conta do Telegram desvinculada!',
    'Ошибка отвязки Telegram аккаунта': 'Não foi possível desvincular sua conta do Telegram',

    /* my novels */
    'Мои новеллы': 'Minhas novels',
    'У вас нет опубликованных новелл': 'Você não tem novels publicadas',
    'Всего ходов: {0}': 'Total de jogadas: {0}',
    'Нет данных': 'Ainda sem dados',
    'Месяц': 'Mês',
    'Ходы': 'Jogadas',
    'Январь': 'Janeiro',
    'Февраль': 'Fevereiro',
    'Март': 'Março',
    'Апрель': 'Abril',
    'Май': 'Maio',
    'Июнь': 'Junho',
    'Июль': 'Julho',
    'Август': 'Agosto',
    'Сентябрь': 'Setembro',
    'Октябрь': 'Outubro',
    'Ноябрь': 'Novembro',
    'Декабрь': 'Dezembro',

    /* admin */
    'Администрирование': 'Administração',
    'Жалобы пользователей': 'Denúncias de usuários',
    'Скрыть форму': 'Ocultar formulário',
    'Опубликовать новость': 'Publicar notícia',
    'Заголовок': 'Título',
    'Slug (латиницей, напр. konkurs-iyun)': 'Slug (letras latinas, ex.: concurso-junho)',
    'HTML-содержимое новости': 'Conteúdo HTML da notícia',
    'Публикация...': 'Publicando...',
    'Опубликовать': 'Publicar',
    'Новость опубликована!': 'Notícia publicada!',

    /* auth modal */
    'Создать аккаунт': 'Criar conta',
    '⭐ Получите 100 звёзд за регистрацию + ещё 100 за привязку Telegram = 200 БЕСПЛАТНЫХ звёзд!': '⭐ 100 estrelas pelo cadastro + mais 100 por vincular o Telegram = 200 estrelas GRÁTIS!',
    'Зарегистрируйтесь, чтобы продолжить игру!': 'Cadastre-se para continuar jogando!',
    'Имя пользователя': 'Nome de usuário',
    'Подтвердить пароль': 'Confirmar senha',
    'Нажимая кнопку «Создать аккаунт», вы принимаете': 'Ao clicar em “Criar conta”, você aceita os nossos',
    'Пользовательское соглашение': 'Termos de Serviço',
    'Политику конфиденциальности': 'Política de Privacidade',
    'Уже есть аккаунт? Войдите': 'Já tem uma conta? Entre',
    'Проверьте почту': 'Confira seu e-mail',
    'Аккаунт создан! Мы отправили письмо со ссылкой для подтверждения email.': 'Conta criada! Enviamos um link para você confirmar seu e-mail.',
    'После подтверждения вы сможете войти в аккаунт.': 'Depois de confirmar, você poderá entrar na sua conta.',
    'Вход в аккаунт': 'Entrar',
    'Чтобы продолжить, войдите в аккаунт или зарегистрируйтесь': 'Entre ou crie uma conta para continuar',
    'Имя пользователя или email': 'Nome de usuário ou e-mail',
    'Нужен аккаунт? Зарегистрируйтесь': 'Precisa de uma conta? Cadastre-se',
    'Забыли пароль?': 'Esqueceu a senha?',
    'Восстановление пароля': 'Recuperação de senha',
    'Введите ваше имя пользователя или email. Если аккаунт найден и email подтверждён — мы отправим ссылку для сброса пароля.': 'Digite seu nome de usuário ou e-mail. Se a conta existir e o e-mail estiver confirmado, enviaremos um link para redefinir a senha.',
    'Отправить письмо': 'Enviar e-mail',
    'Вернуться ко входу': 'Voltar para o login',
    'Письмо отправлено': 'E-mail enviado',
    'Письмо со ссылкой для сброса пароля отправлено на ваш email.': 'Enviamos um link para redefinir a senha para o seu e-mail.',
    'Ссылка действительна 1 час.': 'O link é válido por 1 hora.',
    'Пожалуйста, заполните все поля': 'Preencha todos os campos',
    'Пароли не совпадают': 'As senhas não coincidem',
    'Имя пользователя может содержать только английские буквы, цифры и нижнее подчёркивание': 'O nome de usuário só pode conter letras latinas, números e sublinhados',
    'Введите корректный email': 'Digite um e-mail válido',
    'Аккаунт создан! Проверьте почту для подтверждения.': 'Conta criada! Confira seu e-mail para confirmá-la.',
    'Вход выполнен успешно!': 'Login realizado com sucesso!',
    'Ошибка регистрации': 'Falha no cadastro',
    'Ошибка входа': 'Falha no login',
    'Введите имя пользователя или email': 'Digite seu nome de usuário ou e-mail',

    /* reset password page */
    'Пожалуйста, заполните оба поля.': 'Preencha os dois campos.',
    'Пароли не совпадают.': 'As senhas não coincidem.',
    'Пароль должен содержать минимум 6 символов.': 'A senha deve ter pelo menos 6 caracteres.',
    'Не удалось сбросить пароль.': 'Não foi possível redefinir sua senha.',
    'Пароль изменён!': 'Senha alterada!',
    'Теперь вы можете войти с новым паролем.': 'Agora você pode entrar com sua nova senha.',
    'Введите новый пароль для вашего аккаунта.': 'Escolha uma nova senha para sua conta.',
    'Ссылка недействительна. Запросите новую.': 'Este link não é válido. Solicite um novo.',
    'Сохранить пароль': 'Salvar senha',

    /* confirm email page */
    'Токен подтверждения отсутствует.': 'O token de confirmação está ausente.',
    'Email успешно подтверждён!': 'Seu e-mail foi confirmado!',
    'Аккаунт создан! Подтвердите email по ссылке из письма и получите {0} звёзд.': 'Conta criada! Confirme seu e-mail pelo link que enviamos e ganhe {0} estrelas.',
    '📧 Подтвердите email после регистрации и получите {0} бесплатных звёзд!': '📧 Confirme seu e-mail depois de se cadastrar e ganhe {0} estrelas grátis!',
    '📧 Новый игрок? Зарегистрируйтесь и подтвердите email — получите {0} звёзд бесплатно!': '📧 É novo por aqui? Cadastre-se e confirme seu e-mail para ganhar {0} estrelas grátis!',
    'Вам начислено {0} звёзд за подтверждение email.': '{0} estrelas foram adicionadas ao seu saldo por confirmar seu e-mail.',
    'Не удалось подтвердить email.': 'Não foi possível confirmar seu e-mail.',
    'Ошибка соединения. Попробуйте позже.': 'Erro de conexão. Tente novamente mais tarde.',
    'Подтверждаем ваш email…': 'Confirmando seu e-mail…',
    'Email подтверждён!': 'E-mail confirmado!',
    'Перейти на главную': 'Ir para o início',
  },
};

export default account;
